import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GetAllCsmResponse } from "@/core/types/(api)/csm";
import { MEDIUM_LIVED_CACHE } from "@/lib/constants/cache";

import { customerSuccessKeys } from "../keyFactory";
import { getCsmList } from "../queryFunctions/getCsmList";

type UseCsmListProps<TData = GetAllCsmResponse> = {
  enabled?: boolean;
  select?: (data: GetAllCsmResponse) => TData;
};

type CsmListQueryOptions = UseQueryOptions<
  GetAllCsmResponse,
  unknown,
  GetAllCsmResponse,
  ReturnType<typeof customerSuccessKeys.csmList>
>;

export function useCsmList<TData = GetAllCsmResponse>({
  enabled = true,
  select,
}: UseCsmListProps<TData> = {}) {
  return useQuery({ ...optionFactory(enabled), select });
}

function optionFactory(enabled: boolean) {
  return {
    enabled,
    queryFn: getCsmList,
    queryKey: customerSuccessKeys.csmList(),
    staleTime: MEDIUM_LIVED_CACHE,
  } satisfies CsmListQueryOptions;
}
